<div class="wapp">
  <form novalidate (ngSubmit)="handleSubmit()" [formGroup]="form">
    <ngx-weditor formControlName="content"></ngx-weditor>
  </form>
</div>
<div><code>{{ form.value.content }}</code></div>
